import React from 'react';
import cn from 'classnames';
import {StandardProps} from '.';

export interface TouchRippleProps extends StandardProps<React.HTMLAttributes<HTMLSpanElement>> {
  targetRef?: React.MutableRefObject<any>;
}

export const TouchRipple: React.FC<TouchRippleProps> = ({className, targetRef, ...restProps}) => {
  const rootRef = React.useRef<HTMLSpanElement>(null);

  React.useEffect(() => {
    const targetEl = targetRef?.current;
    const rootEl = rootRef?.current;

    let timeout;

    if (targetEl && rootEl) {
      targetEl.addEventListener('click', (e) => {
        const containerEl = document.createElement('span');
        containerEl.className = 'touch-ripple__container';

        const rippleEl = document.createElement('span');
        rippleEl.className = 'touch-ripple__ripple';

        containerEl.appendChild(rippleEl);

        const targetRect = targetEl.getBoundingClientRect();

        rippleEl.style.left = e.clientX - targetRect.left + 'px';
        rippleEl.style.top = e.clientY - targetRect.top + 'px';

        rootEl.innerHTML = '';

        rootEl.appendChild(containerEl);

        timeout = setTimeout(() => {
          containerEl.remove();
        }, 1000);
      });
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [targetRef]);

  return <span ref={rootRef} className={cn('touch-ripple', className)} {...restProps} />;
};

export default TouchRipple;
